import { render, staticRenderFns } from "./land-genplan.vue?vue&type=template&id=51ca4170"
import script from "./land-genplan.vue?vue&type=script&lang=js"
export * from "./land-genplan.vue?vue&type=script&lang=js"
import style0 from "./land-genplan.vue?vue&type=style&index=0&id=51ca4170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports